module.exports = __webpack_public_path__ + "static/media/minus.e2890ac1.svg";